// extracted by mini-css-extract-plugin
export default {"root":"_404_root__TPF5n","logo":"_404_logo__71SzS"};